import { Company } from ".";
import Entry from "./Entry";

export default class Brand extends Entry {
  static type = "brands";

  company?: Company;

  get type(): string {
    return Brand.type;
  }
}
